import React from 'react';
import { useQuerySegmentResults } from './segmentResultActions';
import { showFeedback } from '../../../feedback/feedbackReducer';
import { useDispatch } from 'react-redux';
import { SalvDataTag, SalvFieldHeader, SalvProgressCircle } from '@salvapp/ui-components';
import { InternalApiEntityGroup, InternalApiEntityType } from '../../../api-internal';
import InternalLink from '../../../common/InternalLink';
import { generatePath } from 'react-router';
import { InternalNavigation } from '../../../navigation/helper';

interface Props {
  segment: InternalApiEntityGroup;
}
const SegmentResults = ({ segment }: Props) => {
  const { code, entityType, fullCalculationState } = segment;
  const dispatch = useDispatch();

  const {
    data: segmentResults,
    isPending: isSegmentResultsPending,
    isError: isSegmentResultsError,
  } = useQuerySegmentResults({ code, fullCalculationState });

  if (isSegmentResultsError) {
    dispatch(
      showFeedback({
        message: 'Could not load Entity Samples',
        success: false,
      })
    );
    return <div />;
  }

  return (
    <div className={'segment-results'}>
      <SalvFieldHeader
        label={'Sample ' + (entityType === InternalApiEntityType.PERSON ? '(Person ID)' : '(Transaction ID)')}
        className={'m-b-16'}
      />
      {isSegmentResultsPending ? (
        <SalvProgressCircle />
      ) : !segmentResults.length ? (
        fullCalculationState !== 'STARTED' ? (
          'No Entities match this Segment'
        ) : (
          <div className={'calculation-in-progress-message'} style={{ display: 'flex', gap: '8px' }}>
            <span>{'No Entities have yet matched this Segment. Calculation is in progress.'}</span>
            <SalvProgressCircle />
          </div>
        )
      ) : (
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {segmentResults.map((segmentResult) => (
            <SalvDataTag
              key={segmentResult.entityId}
              value={
                <InternalLink
                  title={segmentResult.entityId}
                  link={generatePath(
                    entityType === InternalApiEntityType.PERSON
                      ? InternalNavigation.person
                      : InternalNavigation.transaction,
                    { id: segmentResult.entityId }
                  )}
                />
              }
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SegmentResults;
